import React from "react";
// UI Framework
import { toast } from "react-toastify";
// Common components
import { Button, TextInput, FullScreenLoading } from "src/Components";
// Requests
import { getIVConfig, setIVConfig } from "src/Requests/automaticMarketMaking";
// Utilities
import { packetErrorHandler } from "src/Utils/requestUtils";
import { addComma, removeComma } from "src/helper";

interface IProps {
  onClose: () => void;
}

const SettingConfig = ({ onClose }: IProps) => {
  // local store
  const [loading, setLoading] = React.useState(false);
  const [minHedgerOptionVolume, setMinHedgerOptionVolume] = React.useState<
    string | number
  >();

  React.useEffect(() => {
    getIVConfig()
      .then((res) => {
        setMinHedgerOptionVolume(res.minHedgerOptionVolume);
      })
      .catch((err) => {
        toast.error(err.msg);
      });
  }, []);

  const changeHandler = (name: string, value: any) => {
    setMinHedgerOptionVolume(removeComma(value));
  };

  const clickHandler = () => {
    setLoading(true);
    setIVConfig({ minHedgerOptionVolume: Number(minHedgerOptionVolume) })
      .then((resp) => {
        toast.success(resp.msg);
        onClose();
      })
      .catch(packetErrorHandler)
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="!w-80 gap-3 p-2 px-2 !mx-auto flex flex-col justify-center items-center">
      {loading ? <FullScreenLoading /> : <></>}
      <TextInput
        label="حداقل حجم آپشن هجر"
        name="longtermHedgerVolatility"
        onChange={changeHandler}
        value={addComma(minHedgerOptionVolume ?? 0)}
        extraLabel
      />

      <div className="mt-6 self-center">
        <Button text="ثبت" onClick={clickHandler} variant="contained" />
      </div>
    </div>
  );
};

export default SettingConfig;
